import styled from 'styled-components'

import { helpers } from 'styles'

export const Title = styled.span`
	display: flex;
	align-items: center;
	column-gap: 12px;
	color: ${helpers.color.textHeader};
	margin-bottom: 4px;

	&:only-child {
		margin-bottom: 0;
	}
`
